// extracted by mini-css-extract-plugin
module.exports = {"content":"View_content__2V6iU","container-video":"View_container-video__3-i7C"};